import React from "react";
import { Card, Typography, Row, Col } from "antd";

const { Text } = Typography;

const SeriesCard = ({ data }) => {
  return (
    <div style={{ padding: "20px 60px", display: "flex" }}>
      <Card
        title={<span>Series Type: {data?.seriesType}</span>}
        bordered={false}
        style={{
          width: "auto",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
        headStyle={{
          backgroundColor: "#fafafa",
          textAlign: "left",
        }}
      >
        <Row gutter={[16, 16]}>
          {data?.seriesFrom && (
            <Col span={12}>
              <Text strong>Series From:</Text> <Text>{data?.seriesFrom}</Text>
            </Col>
          )}
          {data?.seriesTo && (
            <Col span={12}>
              <Text strong>Series To:</Text> <Text>{data?.seriesTo}</Text>
            </Col>
          )}

          <Col span={12}>
            <Text strong>CP Name:</Text> <Text>{data?.cpName || "N/A"}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Owner Name:</Text>{" "}
            <Text>{data?.cpOwner || "N/A"}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Branch Name:</Text>{" "}
            <Text>{data?.branchName || "N/A"}</Text>
          </Col>
          {data?.clientName && (
            <Col span={12}>
              <Text strong>Client Name:</Text> <Text>{data?.clientName}</Text>
            </Col>
          )}

          <Col span={12}>
            <Text strong>Hub Name:</Text> <Text>{data?.hubName}</Text>
          </Col>

          {data?.createdDate && (
            <Col span={12}>
              <Text strong>Assigned Date:</Text>{" "}
              <Text>{data?.createdDate || "N/A"} </Text>
            </Col>
          )}
          <Col span={12}>
            <Text strong>Phone No:</Text>{" "}
            <Text>{data?.mobileNo || "N/A"} </Text>
          </Col>
          <Col span={12}>
            <Text strong>Email:</Text> <Text>{data?.email || "N/A"} </Text>
          </Col>
          <Col span={12}>
            <Text strong>Address:</Text> <Text>{data?.cpAddress || "N/A"}</Text>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default SeriesCard;
